import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostVoiceTranscriptionTermsAccept,
	PostVoiceTranscriptionTermsAcceptParams,
	PostVoiceTranscriptionTermsAcceptResponse,
} from 'domain/usecases/others/voice-transcription';

export class RemotePostVoiceTranscriptionTermsAccept implements PostVoiceTranscriptionTermsAccept {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostVoiceTranscriptionTermsAcceptResponse>,
	) {}

	async post(
		params: PostVoiceTranscriptionTermsAcceptParams,
	): Promise<PostVoiceTranscriptionTermsAcceptResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
			case HttpStatusCode.created:
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
